<template>
    <div class="vx-row">
      <div class="vx-col flex">
          <div class="vx-col sm:w-1/2 w-full">
              <vs-button color="success" @click="editRecord" style="width: 70px; padding: 8px; margin-right: 5px; margin-left: 10px; height: 37px">編集</vs-button>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
              <vs-button color="danger" @click="deleteRecord" style="width: 70px; padding: 8px; margin-right: 5px; margin-left: 10px; height: 37px">削除</vs-button>
          </div>
      </div>
    </div>
</template>

<script>
import EventBus from '../../EventBus'
export default {
  name: 'CellRendererActionsButton',
  methods: {
    editRecord() {
      EventBus.$emit('editRecord', this.params.data)
    },
    deleteRecord() {
      EventBus.$emit('deleteRecord', this.params.data)
    },
  },
}
</script>
<style lang="scss" scoped>
.text-gray{
  color:darkgray;
}
</style>